import React, {useEffect, useState} from 'react';
import {Paper, Grid, Typography, Container} from '@material-ui/core'
import {has, filter, includes} from 'lodash';
import IS from '../ImageService'

export default function DocumentCard(props){
    const [audio, setAudio]= useState(null);
    
    useEffect(() => {
        async function getAudio(){
            if(has(props.media, "assetKey"))setAudio(await IS(props.media.assetKey))
        }
        getAudio();
    }, [props.media]);
    

    if(!props.media) return null;
    return <div>I see documents</div>
    
    
    
            
}